import { Component, signal, Input, effect, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { TruckerActivity } from '@app/common-codes/models/matwins-tenant/TruckerActivity.model';
import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { LookupProfile, LookupService, LookupItem } from '@app/common-codes/services/LookupService';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';
import { IListType } from '@app/common-codes/components/_primitives/IListType';

import { TruckerActivityDetailComponent } from '../activity-detail/trucker-activity-detail.component';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { ComponentInstancesService } from '@app/common-codes/services/componentInstances.service';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { IFilterCriteria, IFilterOperator } from '@app/common-codes/components/_primitives/IFilterCriteria';
import { FilterOption, MultiCriteriaFilterComponent } from '@app/common-codes/components/nested-components/multi-criteria-filter/multi-criteria-filter.component';
import { TimeZoneIconComponent } from '@app/common-codes/components/nested-components/timezone-icon/timezone-icon.component';


@Register(TruckerActivity)
@Component({
  selector: 'app-trucker-activity-list',
  templateUrl: './trucker-activity-list.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ListViewComponent,
    ListTableColumnComponent,
    TranslatePipe,
    TruckerActivityDetailComponent,
    ReactiveBadgeComponent,
    //NgFor,
    MultiCriteriaFilterComponent,
    TimeZoneIconComponent
  ]
})
export class TruckerActivityListComponent extends GenericListComponent<TruckerActivity> {


  override Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  override ComponentEntityClass = TruckerActivity;
  override entityMetaData: IEntityMetaData = new TruckerActivity().GetType();
  override contextMenuItems = []; // No context menu for now
  public ListType = IListType;
  @ViewChild('truckerActivityDetail', { read: TruckerActivityDetailComponent }) detail!: TruckerActivityDetailComponent;

  // Lookups
  activityStatusLookup = signal<LookupItem[]>([]);
  truckerStatusLookup = signal<LookupItem[]>([]);
  truckerValidationStateLookup = signal<LookupItem[]>([]);

  // Options du filtre multicritères (basé sur ActivityStatus)
  filterOptions = signal<FilterOption[]>([]);


  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      { lookupName: "Dock" },
      { lookupName: "PointOfService" },
      { lookupName: "TimeZone" },
      { lookupName: "ActivityStatus" },
      { lookupName: "ActivityDeliveryType" },
      { lookupName: "TruckerStatus" },      // pour le badge dans la colonne
      { lookupName: "TruckerValidationState" }
    ];
    return lookupProfiles;
  }

  modalEntity = signal<TruckerActivity | null>(null);

  constructor(
    _alertModalService: AlertModalService
  ) {
    super();
    this.alertModalService = _alertModalService;

    // Remplir les lookups pour les badges (nécessaires)
    effect(() => {
      const entities = this.listView()?.entities();
      if (entities) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.activityStatusLookup.set(this.lookupService.getLookupData('ActivityStatus'));
        this.truckerStatusLookup.set(this.lookupService.getLookupData('TruckerStatus'));
        this.truckerValidationStateLookup.set(this.lookupService.getLookupData('TruckerValidationState'));
      }
    });

    // Construire les options de filtre à partir du lookup ActivityStatus
    const filterColors: string[] = ['red',  'green', 'orange', 'sky'];
    effect(() => {
      let statusList = this.activityStatusLookup().filter((st) => { return Number.parseInt(st.id) > 0 }).sort((a, b) => { return Number.parseInt(a.id) - Number.parseInt(b.id) });
      //statusList.push(this.activityStatusLookup().filter((st) => { return Number.parseInt(st.id) == -1 })[0]); 
      //statusList
      if (statusList.length) {
        let colorIndex = 0;
        const selectedIds = new Set(this.selectedFilterOptionIds());
        const options: FilterOption[] = statusList.map(item => ({
          id: `activityStatus_${item.key}`,
          label: item.value,
          color: filterColors[colorIndex++ % filterColors.length],
          isSelected: selectedIds.has(`activityStatus_${item.key}`),
          group: 'ActivityStatus',
          fieldName: 'status'
        }));
        this.filterOptions.set(options);
      }
    });

  }

  //override ngOnInit() {
  //  super.ngOnInit();

  //  let uuu = this.RequiredPermissions;
  //}

  //override ngAfterViewInit() {
  //  super.ngAfterViewInit();
  //}

  override getdetailComponent(): GenetricDetailComponent<TruckerActivity> | undefined {
    return this.detail;
  }

  // override editSelectedItem(selectedItem: TruckerActivity) {
  //   super.editSelectedItem(selectedItem);

  //   //this.selectedItem.set(selectedItem);
  //   // this.isModalOpen.set(true);
  // }

  override openCreateModal() {
    super.openCreateModal();

    const emptyEntity = this.getdetailComponent()?.getEmptyEntity();
    this.getdetailComponent()?.editingEntity.set(emptyEntity || null);
    this.selectedItem.set(emptyEntity || null);

    // this.isModalOpen.set(true);
  }

  // closeModal() {
  //   this.isModalOpen.set(false);
  //   this.selectedItem.set(null);
  //   this.refreshList();
  // }

  override async updateEntityProperty(entity: TruckerActivity, property: keyof TruckerActivity, newValue: any): Promise<void> {
    const detailComponent = this.getdetailComponent() as TruckerActivityDetailComponent;
    if (detailComponent) {
      const updatedEntity = Object.assign(new this.ComponentEntityClass(), entity);

      detailComponent.performBeforeSave(updatedEntity);
      updatedEntity[property] = newValue;
      entity[property] = newValue;
      try {
        await this.dataService.update(entity.id, updatedEntity, this.getComponentId());
        this.updateItemInCache(entity);
      } catch (error) {
        console.error(`Failed to update ${String(property)}:`, error);
      }
      // super.updateEntityProperty(updatedEntity, property, newValue);
    }
  }

  handleItemSaved(event: any) {
    this.onItemUpdated(event as TruckerActivity);
  }

  getSkinProperty(key: string): string {
    const r = key.split(' ').filter(Boolean).map(cls => {
      const camelCaseCls = cls.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
      return (this.Skin as any)[camelCaseCls] || cls;
    }).join(' ');
    return r;
  }
  //private selectedStatuses = signal<number[]>([]);
  //private isDockFilterActive = signal<boolean>(false);
    
}
